/* StorageOZ welcome offer 2026-10-27.2. GA4 destination is pending; no contact data is emitted. */
(() => {
  const popup=document.querySelector('[data-first10-popup]');
  if(!popup || popup.dataset.initialized)return;
  popup.dataset.initialized='true';
  const key=popup.dataset.storageKey||'storageoz_welcome5_popup_closed_v1';
  const pendingKey=`${key}_pending`,shownKey=`${key}_shown`,dialogShownKey=`${key}_dialog_shown_v2`,successKey='storageoz_newsletter_success_v1';
  const dialog=popup.querySelector('.first10-popup__dialog'),form=popup.querySelector('.first10-popup__form');
  const fields=popup.querySelector('[data-first10-form-fields]'),success=popup.querySelector('[data-first10-success]');
  const serverSuccess=!!popup.querySelector('[data-first10-server-success]');
  const serverError=!!popup.querySelector('[data-first10-server-error]');
  const teaser=document.querySelector('[data-first10-teaser]');
  const desktop=window.matchMedia('(min-width:750px)');
  const eligible=popup.dataset.eligible==='true';
  const qa=popup.dataset.designMode==='true'||new URLSearchParams(location.search).get('soz_qa')==='newsletter';
  const startedAt=Date.now(),delay=15000,week=7*24*60*60*1000;
  const read=(storage,k)=>{try{return window[storage].getItem(k);}catch(_){return null;}};
  const write=(storage,k,v)=>{try{window[storage].setItem(k,v);}catch(_){}};
  const remove=(storage,k)=>{try{window[storage].removeItem(k);}catch(_){}};
  let known=popup.dataset.knownSubscriber==='true'||read('localStorage',successKey)==='1';
  // Legacy shown mixed teaser impressions and dialog opens. Keep it for desktop frequency only.
  let shown=read('sessionStorage',shownKey)==='1',dialogShown=read('sessionStorage',dialogShownKey)==='1',entrySeen=false,closed=false,openSource='manual';
  let previousFocus=null,previousOverflow='',timer=null;
  const oldClosed=read('localStorage',key);
  if(oldClosed==='1'){closed=true;write('localStorage',key,String(startedAt));}
  else if(oldClosed){closed=Number.isFinite(Number(oldClosed))&&startedAt-Number(oldClosed)<week;if(!closed)remove('localStorage',key);}
  let pending=null;
  const raw=read('sessionStorage',pendingKey);
  if(raw==='1')pending={source:'legacy',at:startedAt};
  else if(raw){try{const p=JSON.parse(raw);if(p.at<=startedAt&&startedAt-p.at<30*60*1000)pending=p;}catch(_){}}

  // Existing Shopify customer-privacy settings decide analytics permission; never grant consent here.
  // These custom events do not automatically become Shopify Forms or GA4 reports.
  const waiting=[],sentViews=new Set();
  const eventNames=new Set(['form_view','teaser_view','teaser_click','teaser_dismiss','close','submit','form_success','form_error']);
  function permitted(){try{return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;}catch(_){return false;}}
  function deliver(name,data){
    if(name.endsWith('_view')){const k=name+':'+data.source;if(sentViews.has(k))return;sentViews.add(k);}
    try{window.Shopify?.analytics?.publish?.('soz_newsletter_'+name,data);}catch(_){}
    // A future direct GA4 installation can consume these without creating a second loader.
    if(typeof window.gtag==='function'){try{window.gtag('event','soz_newsletter_'+name,{...data,transport_type:'beacon'});}catch(_){}}
    window.dispatchEvent(new CustomEvent('soz:newsletter',{detail:{event:'soz_newsletter_'+name,...data}}));
  }
  function track(name,values={}){
    if(qa||!eventNames.has(name))return;
    const clean={source:String(values.source||openSource).slice(0,30),page_type:popup.dataset.pageType||'other',device:desktop.matches?'desktop':'mobile',offer:'welcome5',version:'20261027_2'};
    if(['validation','server'].includes(values.reason))clean.reason=values.reason;
    if(values.result==='server_accepted')clean.result='server_accepted';
    if(permitted())deliver(name,clean);
    else if(!window.Shopify?.customerPrivacy&&waiting.length<20)waiting.push([name,clean]);
  }
  function flush(){
    if(permitted()){
      waiting.splice(0).forEach(([n,d])=>deliver(n,d));
      if(!popup.hidden&&!verified)track('form_view');
      if(teaser&&!teaser.hidden)track('teaser_view',{source:'mobile_teaser'});
    }else waiting.length=0;
  }
  document.addEventListener('visitorConsentCollected',flush);
  if(!window.Shopify?.customerPrivacy&&window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{if(!error)flush();});
  function markSuccessful(){known=true;write('localStorage',successKey,'1');if(teaser)teaser.hidden=true;}
  window.SOZNewsletter={track,markSuccessful,version:'2026-10-27.2',analyticsDestination:'GA4 pending'};
  const verified=serverSuccess&&!!pending;
  if(success)success.hidden=!verified;if(fields)fields.hidden=verified;
  if(verified){markSuccessful();remove('sessionStorage',pendingKey);track('form_success',{source:pending.source,result:'server_accepted'});}
  if(serverError&&pending){remove('sessionStorage',pendingKey);track('form_error',{source:pending.source,reason:'server'});}
  if(!verified&&location.search.includes('customer_posted=')){
    const u=new URL(location.href);u.searchParams.delete('customer_posted');history.replaceState({},'',u.pathname+u.search+u.hash);
  }
  const size=()=>{popup.style.setProperty('--first10-vw',`${window.visualViewport?.width||innerWidth}px`);popup.style.setProperty('--first10-vh',`${window.visualViewport?.height||innerHeight}px`);};
  const visible=el=>{
    const r=el.getBoundingClientRect(),s=getComputedStyle(el);
    return r.width>0&&r.height>0&&r.bottom>0&&r.top<innerHeight&&s.display!=='none'&&s.visibility!=='hidden'&&Number(s.opacity)!==0;
  };
  // Shopify Chat's transparent host fills the viewport even when only its launcher is visible.
  // Read real controls/panels in open shadow roots; retain conservative host geometry if unreadable.
  const chatRoots=new WeakSet();
  const chatObserver=typeof MutationObserver==='function'?new MutationObserver(refresh):null;
  function chatUI(){
    const surfaces=[];let open=false;
    for(const host of document.querySelectorAll('shopify-chat')){
      const controls=[];
      function scan(root,depth){
        if(!root||depth>4)return;
        if(chatObserver&&!chatRoots.has(root)){
          chatRoots.add(root);chatObserver.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-expanded','aria-hidden','hidden','open','class','style']});
        }
        root.querySelectorAll('button[aria-expanded],[role="dialog"],iframe').forEach(el=>controls.push(el));
        root.querySelectorAll('*').forEach(el=>{if(el.shadowRoot)scan(el.shadowRoot,depth+1);});
      }
      scan(host.shadowRoot,0);
      if(!controls.length){if(visible(host))surfaces.push(host);continue;}
      for(const el of controls){
        if(!visible(el))continue;
        surfaces.push(el);
        if(el.getAttribute('role')==='dialog'||el.getAttribute('aria-expanded')==='true')open=true;
      }
    }
    return {open,surfaces};
  }
  const otherModal=()=>[...document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"]')].some(e=>e!==dialog&&visible(e))||chatUI().open;
  const typing=()=>document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
  function stopTimer(){if(timer!==null)clearTimeout(timer);timer=null;}
  function open(source='manual'){
    if(!popup.hidden)return;
    stopTimer();openSource=source;shown=true;dialogShown=true;write('sessionStorage',shownKey,'1');write('sessionStorage',dialogShownKey,'1');
    if(teaser)teaser.hidden=true;
    previousFocus=document.activeElement;previousOverflow=document.documentElement.style.overflow;
    popup.hidden=false;size();popup.classList.add('is-open');popup.setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden';dialog?.focus();
    if(!verified)track('form_view',{source});
  }
  function dismiss(){closed=true;write('localStorage',key,String(Date.now()));stopTimer();if(teaser)teaser.hidden=true;}
  function close(){
    if(popup.hidden)return;
    track('close');dismiss();popup.classList.remove('is-open');popup.setAttribute('aria-hidden','true');popup.hidden=true;document.documentElement.style.overflow=previousOverflow;
    if(previousFocus?.isConnected&&previousFocus.focus)previousFocus.focus();
  }
  function positionEntry(){
    if(!teaser)return false;
    const h=window.visualViewport?.height||innerHeight;
    if(otherModal()||typing()||h<innerHeight*.75)return false;
    const footer=document.querySelector('#First10FooterStorage');if(footer&&visible(footer))return false;
    let bottom=18;
    const width=Math.min(220,innerWidth-24),height=48;
    // Move above any visible purchase bar, chat launcher or cookie panel intersecting this left-hand entry.
    const obstacles=[...document.querySelectorAll('.sticky-add-to-cart__bar,[data-planner-sticky],.buy-buttons-block,iframe[title*="chat" i],#shopify-pc__banner,[id*="cookie-banner"]'),...chatUI().surfaces].filter(visible);
    for(let pass=0;pass<3;pass++){
      for(const el of obstacles){const r=el.getBoundingClientRect();const top=h-bottom-height;
        if(r.left<12+width&&r.right>12&&r.top<h-bottom&&r.bottom>top){
          if(r.height>h*.5)return false;
          bottom=Math.max(bottom,h-r.top+12);
        }
      }
    }
    if(h-bottom-height<100)return false;
    teaser.style.bottom=`${bottom}px`;return true;
  }
  function maybeOffer(){
    stopTimer();
    if(teaser)teaser.hidden=true;
    if(!eligible||known||closed||!popup.hidden||document.visibilityState==='hidden'||chatUI().open)return;
    const remaining=delay-(Date.now()-startedAt);
    if(remaining>0){timer=setTimeout(maybeOffer,remaining);return;}
    if(desktop.matches){
      if(shown||dialogShown)return;
      if(!otherModal()&&!typing()){open('automatic');return;}
    }else if(!dialogShown&&positionEntry()){
      teaser.hidden=false;
      // A passive teaser impression must not consume the next page's invitation.
      if(!entrySeen){entrySeen=true;track('teaser_view',{source:'mobile_teaser'});}
    }
    // Retry briefly when initial display is blocked; scroll/focus/visibility changes remain responsive afterwards.
    if(Date.now()-startedAt<90000)timer=setTimeout(maybeOffer,2000);
  }
  popup.querySelectorAll('[data-first10-close]').forEach(el=>el.addEventListener('click',close));
  document.querySelectorAll('[data-first10-open]').forEach(el=>el.addEventListener('click',()=>{
    const source=el.dataset.first10Source||'manual';if(source==='mobile_teaser')track('teaser_click',{source});open(source);
  }));
  teaser?.querySelector('[data-first10-teaser-close]')?.addEventListener('click',()=>{track('teaser_dismiss',{source:'mobile_teaser'});dismiss();});
  if(form){let submitting=false,invalidSent=false;
    form.addEventListener('invalid',()=>{if(!invalidSent){invalidSent=true;track('form_error',{reason:'validation'});}},{capture:true});
    form.addEventListener('submit',event=>{
      if(submitting){event.preventDefault();return;}submitting=true;
      write('sessionStorage',pendingKey,JSON.stringify({at:Date.now(),source:openSource}));track('submit');
    });
  }
  document.addEventListener('keydown',event=>{
    if(popup.hidden)return;
    if(event.key==='Escape'){event.preventDefault();close();return;}
    if(event.key!=='Tab')return;
    const focusable=[...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex="0"]')].filter(e=>e.getClientRects().length>0);
    const first=focusable[0],last=focusable[focusable.length-1];
    if(!first){event.preventDefault();dialog.focus();}
    else if(event.shiftKey&&(document.activeElement===first||document.activeElement===dialog)){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  });
  let frame=false;
  function refresh(){size();if(!frame){frame=true;requestAnimationFrame(()=>{frame=false;maybeOffer();});}}
  window.addEventListener('scroll',refresh,{passive:true});window.addEventListener('resize',refresh);
  window.visualViewport?.addEventListener('resize',refresh);document.addEventListener('visibilitychange',refresh);document.addEventListener('focusout',refresh);
  if('MutationObserver' in window){const observer=new MutationObserver(refresh);document.querySelectorAll('.sticky-add-to-cart__bar,[data-planner-sticky],shopify-chat,cart-drawer-component,dialog').forEach(el=>observer.observe(el,{attributes:true,attributeFilter:['data-stuck','open','class','aria-hidden','hidden']}));}
  if(verified)open('receipt');else if(serverError&&pending)open(pending.source);else maybeOffer();
})();
